export default "__VITE_ASSET__CAOnyzd5__"